import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { APIs } from '../utils/apis';
import Cookies from 'universal-cookie';
import queryString from 'query-string';

const cookies = new Cookies();

const Login = ({ history, location }) => {
  const parsed = queryString.parse(location.search);
  useEffect(() => {
    if (cookies.get('sub_token')) {
      history.push(parsed.redirect || '/');
    }
  }, []);

  return (
    <Row>
      <Col span={24} className="google-wrapper">
        <h1>
          Sign in with
          <br />
          Google
        </h1>

        <div className="google-btn">
          <a href={APIs.SSO_AUTH} target="_self" referrerPolicy="origin">
            <div className="google-icon-wrapper">
              <img
                className="google-icon-svg"
                alt="google login"
                src="https://pyck-res-bucket.s3.ap-southeast-1.amazonaws.com/clickpost_assets/google_btn.svg"
              />
            </div>
            <p className="btn-text">
              <b>Sign in with Google</b>
            </p>
          </a>
        </div>
      </Col>
    </Row>
  );
};

Login.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object
};

export default Login;
